import { render } from "./media-control-prev.svg?vue&type=template&id=e1e6263c"
const script = {}
script.render = render

export default script